export class BrowseData {
    currentTypeIds: number[];
    includeSeries: boolean;
    subCategory: string;
    publishStatus?: number;
    scheduleStatus?: number;
    maxItems: number;
    currentSort: number;
    currentGenre: string;
    newOnly?: boolean;
    downloadablePriceTypes :PriceTypeFlagEnum
    shippablePriceTypes: PriceTypeFlagEnum
    ageRating?: string;
    completionStatus?: number;
    start?: number;
    sale?: boolean;
    isOnSpotlight?: boolean;
    category?:number;//1 = publication, 2 = game, 3 = merchandise, 4 = bundle
    format?: number;
}

export enum PriceTypeFlagEnum {
    None = 0,
    Free = 1 << 0,
    FreeForRegistered = 1 << 1,
    Paid = 1 << 2,
    NotForSale = 1 << 3,
    SubscriptionOnly = 1 << 4,
    PaidOrSubscription = 1 << 5,
    FreeToReadAndPurchaseble = 1 << 6,
    FreeToReadForRegisteredAndPurchaseble = 1 << 7
}
